module.exports = __webpack_public_path__ + "static/media/Roxane Ouellet.bb4b8be3.png";